import { listBlockedContacts } from '@/services/wootdashBlacklist'
import { onBlacklistChanged } from '@/composables/useConversationRealtime'

// Lista negra no WootDash (substitui a do n8n). Carregada no login (loadBlacklist) e usada
// pelo painel pra esconder conversas de contatos bloqueados. Quem bloqueia é o backend: a etiqueta
// "lista-negra" numa conversa bloqueia o contato (AddConversationTagCommandHandler), então aqui
// só se lê. O backend já não manda conversa de bloqueado no painel; isto é a segunda camada, que
// acompanha bloqueio/desbloqueio ao vivo pelo SignalR ("ListaNegraAlterada").
const blockedContactIds = new Set<string>()
onBlacklistChanged(evt => {
  if (evt.blocked) blockedContactIds.add(evt.contactId)
  else blockedContactIds.delete(evt.contactId)
})

const BLACKLIST_LABEL = 'lista-negra'

/** Mesmo estilo de normalização usado em `ForaDeHorarioTab.vue` (isForaLabel). */
export function isBlacklistLabel(lbl: string): boolean {
  return lbl.toLowerCase().replace(/[\s_]+/g, '-') === BLACKLIST_LABEL
}

export async function loadBlacklist(token: string): Promise<void> {
  const rows = await listBlockedContacts(token)
  blockedContactIds.clear()
  rows.forEach(r => blockedContactIds.add(r.id))
}

export function isContactBlocked(contactId: string): boolean {
  return blockedContactIds.has(contactId)
}

/** Esconde a conversa do contato bloqueado ou com a etiqueta lista-negra. */
export function isBlacklistedConversation(item: { contactId: string; tagNames: string[] }): boolean {
  return blockedContactIds.has(item.contactId) || item.tagNames.some(isBlacklistLabel)
}

interface BlacklistableConversation {
  labels: string[]
}

/** Tela antiga (motor Chatwoot): só filtra pela etiqueta — o bloqueio em si mora no backend. */
export function filterOutBlacklisted<T extends BlacklistableConversation>(conversations: T[]): T[] {
  return conversations.filter(c => !c.labels.some(isBlacklistLabel))
}

/** Usado ao desbloquear um contato, pra parar de filtrar na hora. */
export function forgetBlacklisted(contactId: string): void {
  blockedContactIds.delete(contactId)
}
